import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RiderService } from '../../../../../core/services/rider.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-view-qr-code',
  templateUrl: './view-qr-code.component.html',
  styleUrls: ['./view-qr-code.component.scss']
})
export class ViewQrCodeComponent implements OnInit, OnDestroy {

  @Input() riderId: number;
  public riderCode: number;
  public showCodeRider = false;
  private subscrip: Subscription[] = [];
  private cooldownTimeout: any;
  private twentyMinutes = 20;
  constructor(
    private _riderService: RiderService,
    private sweetAlertHelper: SweetAlertHelper,
  ) { }

  ngOnInit() {
    const hasCooldown = this.checkExistingCooldown();
    if (!hasCooldown) {
      this.getRiderQR();
    }
  }

  private checkExistingCooldown(): boolean {
    const savedUntil = localStorage.getItem(this.getCooldownKey());
    if (!savedUntil) {
      return false;
    }

    const savedCode = localStorage.getItem(this.getCodeKey());
    const code = Number(savedCode);

    if (isNaN(code) || code <= 0) {
      this.clearCooldown();
      return false;
    }

    this.riderCode = code;
    this.startCooldown(new Date(savedUntil));

    return true;
  }

  /**
   * @description para cargar la imagen
   */
  public getRiderQR(): void {
    if (this.riderId) {
      this.subscrip.push(this._riderService.getCodeRider(this.riderId).subscribe(
        (code) => {
          this.riderCode = code;

          const now = new Date();
          const plus20Minutes = new Date(now);
          plus20Minutes.setMinutes(now.getMinutes() + this.twentyMinutes);
          localStorage.setItem(this.getCodeKey(), String(code));
          this.persistCooldown(plus20Minutes);
          this.startCooldown(plus20Minutes);
        }, error => {
          this.sweetAlertHelper.captureException(error);
        }
      ));
    }
  }

  private getCooldownKey(): string {
    return `riderCodeCooldown_${this.riderId}`;
  }

  private getCodeKey(): string {
    return `riderCode_${this.riderId}`;
  }

  private persistCooldown(until: Date): void {
    try {
      localStorage.setItem(this.getCooldownKey(), until.toISOString());
    } catch (_) { }
  }

  private clearCooldown(): void {
    this.showCodeRider = false;
    try {
      localStorage.removeItem(this.getCooldownKey());
    } catch (_) { }
  }

  private startCooldown(until: Date): void {
    this.showCodeRider = true;
    const ms = until.getTime() - Date.now();
    if (this.cooldownTimeout) {
      clearTimeout(this.cooldownTimeout);
    }
    if (ms > 0) {
      this.cooldownTimeout = setTimeout(() => this.clearCooldown(), ms);
    } else {
      this.clearCooldown();
    }
  }

  ngOnDestroy(): void {
    this.subscrip.forEach(sub => sub.unsubscribe());
    if (this.cooldownTimeout) {
      clearTimeout(this.cooldownTimeout);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/rider/components/rider-qr-code/view-qr-code/view-qr-code.component.ts